import { ConsentConditionType, ConsentConditionTypesApi } from '@/api';

export function isConsentConditionType(x: any): x is ConsentConditionType {
	if (typeof x !== 'object') return false;
	if (typeof x.name !== 'string') return false;
	if (typeof x.title !== 'string') return false;
	if (typeof x.description !== 'string') return false;
	return true;
}

export class ConsentConditionTypeModule {
	private api: ConsentConditionTypesApi;

	constructor() {
		this.api = new ConsentConditionTypesApi();
	}

	public async getConsentConditionTypes(): Promise<ConsentConditionType[]> {
		const res = await this.api.getConsentConditionTypes();
		if (res != undefined && res.data != undefined && res.data.data != undefined) {
			return res.data.data;
		}
		return [];
	}
}
